import UserListQuery from './UserListQuery'

export default UserListQuery
